import { inject as a, ref as l, computed as c, unref as s, isRef as u } from "vue";
import m from "./index702.js";
import i from "./index703.js";
const f = (t) => (e, o) => d(e, o, s(t)), d = (t, e, o) => i(o, t, t).replace(
  /\{(\w+)\}/g,
  (x, n) => {
    var r;
    return `${(r = e?.[n]) != null ? r : `{${n}}`}`;
  }
), g = (t) => {
  const e = c(() => s(t).name), o = u(t) ? t : l(t);
  return {
    lang: e,
    locale: o,
    t: f(t)
  };
}, p = /* @__PURE__ */ Symbol("localeContextKey"), y = (t) => {
  const e = t || a(p, l());
  return g(c(() => e.value || m));
};
export {
  g as buildLocaleContext,
  f as buildTranslator,
  p as localeContextKey,
  d as translate,
  y as useLocale
};
